import React from 'react'
import { BorderRadius, Shadow } from '../types'

interface StylePickerProps {
  borderRadius: BorderRadius
  shadow: Shadow
  onBorderRadiusChange: (value: BorderRadius) => void
  onShadowChange: (value: Shadow) => void
}

const BORDER_RADIUS_OPTIONS: { value: BorderRadius; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'sm', label: 'Small' },
  { value: 'md', label: 'Medium' },
  { value: 'lg', label: 'Large' },
  { value: 'xl', label: 'XL' },
  { value: 'full', label: 'Full' },
]

const SHADOW_OPTIONS: { value: Shadow; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'sm', label: 'Small' },
  { value: 'md', label: 'Medium' },
  { value: 'lg', label: 'Large' },
]

export function StylePicker({ borderRadius, shadow, onBorderRadiusChange, onShadowChange }: StylePickerProps) {
  return (
    <div className="space-y-4">
      {/* Border Radius */}
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-2">Border Radius</label>
        <div className="flex gap-1">
          {BORDER_RADIUS_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onBorderRadiusChange(option.value)}
              className={`flex-1 px-2 py-1.5 text-xs rounded cursor-pointer transition-colors ${
                borderRadius === option.value
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* Shadow */}
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-2">Shadow</label>
        <div className="flex gap-1">
          {SHADOW_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onShadowChange(option.value)}
              className={`flex-1 px-2 py-1.5 text-xs rounded cursor-pointer transition-colors ${
                shadow === option.value
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
